var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchAccept(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1729585468360,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 56957,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9,
    height: 9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M814.788 210.212c16.695 16.695 16.695 43.763 0 60.457-16.695 16.695-43.763 16.695-60.457 0-133.56-133.559-350.102-133.559-483.662 0-133.559 133.56-133.559 350.102 0 483.662 133.56 133.559 350.102 133.559 483.662 0 94.922-94.923 124.66-235.01 79.576-358.981-8.069-22.189 3.377-46.718 25.566-54.787 22.188-8.069 46.717 3.377 54.786 25.566 56.334 154.908 19.16 330.028-99.47 448.66-166.95 166.948-437.628 166.948-604.577 0-166.95-166.95-166.95-437.628 0-604.577 166.949-166.95 437.627-166.95 604.576 0zM639.084 392.92c15.893-17.46 42.931-18.73 60.391-2.836 17.46 15.893 18.73 42.93 2.837 60.39L503.48 668.905c-16.582 18.216-45.087 18.687-62.261 1.028l-112.4-115.576c-16.46-16.925-16.084-43.99 0.842-60.451s43.99-16.084 60.452 0.842l80.723 83.004L639.084 392.92z",
    fill: "#ffffff",
    "p-id": 56958
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchAccept);
export default __webpack_public_path__ + "static/media/batch-accept.3c090976506038473ad959a8d40ce46e.svg";
export { ForwardRef as ReactComponent };